import moment from 'moment-timezone';

const DATE_FORMAT = 'MM/DD/YYYY';
const TIME_FORMAT = 'h:mm:ss A';
const TIMEZONE_FORMAT = 'z';

export function convertISOTimestampToFormattedComponentsInLocalTime(timestamp: string) {
  // The moment.tz.guess() is required because of this: https://github.com/moment/moment/issues/162#issuecomment-182539707
  const localizedTimestamp = moment(timestamp).tz(moment.tz.guess());

  return {
    date: localizedTimestamp.format(DATE_FORMAT),
    time: localizedTimestamp.format(TIME_FORMAT),
    timezone: localizedTimestamp.format(TIMEZONE_FORMAT),
  };
}
